import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Spinner } from 'react-bootstrap-old';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  isLoading: PropTypes.bool
};

const defaultProps = {
  children: null,
  isLoading: false,
};

const LoadingSpinner = (props) => {
  const { children, isLoading } = props;
  const spinnerContainerClassNames = classNames('spinner-container', { show: isLoading });

  return (
    <div className="common-component-loading-spinner">
      <div className={spinnerContainerClassNames} role="spinner">
        <Spinner variant="primary" className="spinner" animation="border" />
      </div>
      {children}
    </div>
  );
};

LoadingSpinner.propTypes = propTypes;
LoadingSpinner.defaultProps = defaultProps;
export default LoadingSpinner;
